import React from 'react';
import { motion } from 'framer-motion';

interface SleepStageBarProps {
  stage: 'awake' | 'light' | 'deep' | 'rem';
  duration: number;
  percentage: number;
  maxDuration: string;
  isSelected?: boolean;
  onSelect?: () => void;
}

const stageColors = {
  awake: 'bg-gray-400',
  light: 'bg-blue-400',
  deep: 'bg-purple-500',
  rem: 'bg-indigo-500'
};

const stageNames = {
  awake: 'AWAKE',
  light: 'LIGHT',
  deep: 'SWS (DEEP)',
  rem: 'REM'
};

export function SleepStageBar({ 
  stage, 
  duration, 
  percentage, 
  maxDuration,
  isSelected,
  onSelect 
}: SleepStageBarProps) {
  const hours = Math.floor(duration / 60);
  const minutes = Math.round(duration % 60);
  const timeString = `${hours}:${minutes.toString().padStart(2, '0')}`;

  return (
    <button 
      onClick={onSelect}
      className={`w-full space-y-1 transition-opacity ${
        isSelected ? 'opacity-100' : 'opacity-70 hover:opacity-100'
      }`}
    >
      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <span>{stageNames[stage]}</span>
        <div className="flex items-center gap-2">
          <span>{Math.round(percentage)}%</span>
          <span>{timeString}</span>
        </div>
      </div>
      <div className="h-4 bg-muted/30 rounded-full overflow-hidden">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 1, ease: "easeOut" }}
          className={`h-full ${stageColors[stage]} ${isSelected ? 'opacity-100' : 'opacity-70'}`}
        />
      </div>
    </button>
  );
}